export const STOP = "stop";
export const START = "start";

export enum DrawerType
{
      DRAWER_SEARCH_RESULTS = "Search results",
      DRAWER_FILTER_SEARCH_MAP = "Filter",
      DRAWER_CART = "cart",
      DRAWER_INFO_IMAGE = "info",

      // DRAWER_ = "BookingImage",
      DRAWER_INFO_AOI = "Info AOI",
      // DRAWER_ = "OrderTaskingUser",
      DRAWER_SETTING = "Setting basemap",

      DRAWER_NOTIFICATIONS = "notification",
      DRAWER_FILTER_ARCHIVE = "Filter archive oder by admin",
      DRAWER_FILTER_FEEDBACK = "Filter feedback",
      DRAWER_SORT_FEEDBACK = "Sort feedback",
      DRAWER_VIEW_FEEDBACK = "View feedback",
      DRAWER_FILTER_HISTORY = "Filter history",
      DRAWER_SORT_HISTORY = "Sort history",

}

export enum HistoryType
{
      UPDATE = 'update',
      DOWNLOAD = 'download'
}

export enum HistoryDownloadStatus
{
      ERROR = 'ERROR',
      SUCCESS = 'SUCCESS'
}


export enum OrderStatus
{
      DONE = "done",
      CANCEL = "cancel",
      PROCESSING = "processing",
}

export enum PriorityLevel
{
      LOW = "low",
      MEDIUM = "medium",
      HIGH = "high",
}